/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_More_Stats_PeaksInputs */

const en_ui_more_stats_peaks = /** @type {(inputs: Ui_More_Stats_PeaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peak power`)
};

const de_ui_more_stats_peaks = /** @type {(inputs: Ui_More_Stats_PeaksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spitzen`)
};

/**
* | output |
* | --- |
* | "Peak power" |
*
* @param {Ui_More_Stats_PeaksInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_more_stats_peaks = /** @type {((inputs?: Ui_More_Stats_PeaksInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_More_Stats_PeaksInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_more_stats_peaks(inputs)
	return de_ui_more_stats_peaks(inputs)
});